import React from 'react';
import { Home } from '../pages/home/Home';
import { Account } from '../pages/home/account/Account';
import { ChangeMail } from '../pages/home/account/ChangeMail';
import { ChangePass } from '../pages/home/account/ChangePass';
import { ChangePlan } from '../pages/home/account/ChangePlan';
import { ChangeCreditCard } from '../pages/home/account/ChangeCreditCard';
import { JobOffer } from '../pages/home/job/JobOffer';
import { JobOfferDetail } from '../pages/home/job/JobOfferDetail';
import { JobOfferEditContents } from '../pages/home/job/JobOfferEditContents';
import { Checkin } from '../pages/home/checkin/Checkin';
import { ChatList } from '../pages/home/chat/ChatList';
import { ChatRoom } from '../pages/home/chat/ChatRoom';
import { ModificationList } from '../pages/home/modification/ModificationList';
import { Payment } from '../pages/home/payment/Payment';
import { ReceiptList } from '../pages/home/receipt/ReceiptList';
import { NotFound } from '../pages/NotFound';
import { PaymentConfirm } from '../pages/home/payment/PaymentConfirm';
const routes = [
    {
        path: '/',
        exact: true,
        children: React.createElement(Home, null),
        component: Home,
    },
    {
        path: '/account',
        children: React.createElement(Account, null),
        exact: true,
        component: Account,
        redirect: true,
    },
    {
        path: '/account/change_mail',
        children: React.createElement(ChangeMail, null),
        exact: true,
        component: ChangeMail,
        redirect: true,
    },
    {
        path: '/account/change_pass',
        children: React.createElement(ChangePass, null),
        exact: true,
        component: ChangePass,
        redirect: true,
    },
    {
        path: '/account/change_plan',
        children: React.createElement(ChangePlan, null),
        exact: true,
        component: ChangePlan,
        redirect: true,
    },
    {
        path: '/account/change_creditcard',
        children: React.createElement(ChangeCreditCard, null),
        exact: true,
        component: ChangeCreditCard,
        redirect: true,
    },
    {
        path: '/job_offer',
        children: React.createElement(JobOffer, null),
        exact: true,
        component: JobOffer,
        redirect: true,
    },
    {
        path: '/job_offer/detail/:id',
        children: React.createElement(JobOfferDetail, null),
        exact: false,
        component: JobOfferDetail,
        redirect: true,
    },
    {
        path: '/job_offer/edit_contents',
        children: React.createElement(JobOfferEditContents, null),
        exact: true,
        component: JobOfferEditContents,
        redirect: true,
    },
    {
        path: '/checkin',
        children: React.createElement(Checkin, null),
        exact: true,
        component: Checkin,
        redirect: true,
    },
    {
        path: '/chat_list',
        children: React.createElement(ChatList, null),
        exact: true,
        component: ChatList,
        redirect: true,
    },
    {
        path: '/chat_list/:id',
        children: React.createElement(ChatRoom, null),
        exact: false,
        component: ChatRoom,
        redirect: true,
    },
    {
        path: '/modification_list',
        children: React.createElement(ModificationList, null),
        exact: true,
        component: ModificationList,
        redirect: true,
    },
    {
        path: '/payment',
        children: React.createElement(Payment, null),
        exact: true,
        component: Payment,
        redirect: true,
    },
    {
        path: '/payment/confirm',
        children: React.createElement(PaymentConfirm, null),
        exact: true,
        component: PaymentConfirm,
        redirect: true,
    },
    {
        path: '/receipt_list',
        children: React.createElement(ReceiptList, null),
        exact: true,
        component: ReceiptList,
        redirect: true,
    },
    {
        path: '*',
        children: React.createElement(NotFound, null),
        exact: false,
        component: NotFound,
    },
];
export default routes;
